import { getDataForRenderScene } from "../../redux/reducers/ui/selectors/sceneSelectors";
import { IRenderConfig, IStudioStage } from "../../redux/reducers/ui/uiTypes";
import { store } from "../../redux/store";
import { IRenderSceneConfigData } from "../../services/api/3d/RenderSceneApi/type";
import { EnvironmentService } from "../../services/EnvironmentService";

/**
 * @deprecated old function, need to use getDataForRenderScene selector instead
 * This function generates the data to be sent for rendering a scene.
 */
export function genDataSceneToSend(body: any): IRenderSceneConfigData {
  let ProjectID = 1;
  const stage = EnvironmentService.getActiveStage() as IStudioStage;

  // try {
  //   const projectID = ProjectService.getProjectID();
  //   if (projectID !== null) {
  //     ProjectID = projectID;
  //   } else {
  //     console.error(
  //       "Project ID not found in window or URL. Default projectID=1 will be used."
  //     );
  //   }
  // } catch (error: any) {
  //   console.error(error.message);
  // }

  const state = store.getState();

  const data = getDataForRenderScene(body)(state);

  return data;
}
